import { computed, Injectable, Signal, signal } from '@angular/core';
import { User } from '../../auth/models/user';
import { Operation } from '../../auth/models/operation';

export interface AuthState {
  user: User;
  operation: Operation;
  operations: Operation[];
}

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  state = signal({
    user: null,
    operation: null,
    operations: [],
  } as AuthState);

  constructor() {}

  public set<K extends keyof AuthState>(key: K, data: AuthState[K]) {
    this.state.update(currentValue => ({ ...currentValue, [key]: data }));
  }

  public setState(partialState: Partial<AuthState>): void {
    this.state.update(currentValue => ({ ...currentValue, ...partialState }));
  }

  public select<K extends keyof AuthState>(key: K): Signal<AuthState[K]> {
    return computed(() => this.state()[key]);
  }
}
